import React from 'react';

import OutsideClickHandler from 'react-outside-click-handler';

import './index.sp.scss';

import SpBasicTemplate from 'components/templates/SpBasicTemplate';
import SpSuggestList from 'components/molecules/SpSuggestList';
import TextBox from 'components/atoms/Input/TextBox';
import NormalCheckBoxInput from 'components/atoms/Input/NormalCheckBoxInput';
import SpInputLine from 'components/molecules/SpInputLine';
import PcErrorArea from 'components/molecules/PcErrorArea';
import PulldownInput from 'components/atoms/Input/PulldownInput';
import {
  getChoiceLabel,
  getChoiceValues,
}from 'utils';

const PresentSP = ({
  corpName,
  facilityName,
  capacity,
  userName,
  tel,
  email,
  emailConf,
  zip,
  municipality,
  houseNumber,
  addressNames,
  capacityList,
  typeList,
  handleChangeCorpName,
  handleChangeFacilityName,
  handleChangeCapacity,
  handleChangeUserName,
  handleChangeTel,
  handleChangeEmail,
  handleChangeEmailConf,
  handleChangeZip,
  handleChangeMunicipality,
  handleClickAddressSuggest,
  handleChangeHouseNumber,
  onClickMainButton,
  valid,
  errorDispMap,
  isApiError,
  handleClickAddressSuggestAway,
  isOpenAddress,
  lpMode,
}) => {
  const listValues = getChoiceValues(typeList.title);
  return (
    <div className="InfoSp">
      <SpBasicTemplate 
        path={window.location.pathname}
        onClickMainButton={onClickMainButton}
        valid={valid}
        isApiError={isApiError}
        lpMode={lpMode}
      >

        <SpInputLine title="法人名">
          <TextBox
            name="corpName"
            val={corpName}
            onChange={handleChangeCorpName}
            placeholder="株式会社リクルートスタッフィング"
            maxLength="300"
            inValid={!!errorDispMap.corpName}
          />
          <PcErrorArea position='relative' message={errorDispMap.corpName} />
        </SpInputLine>

        <SpInputLine title="施設名">
          <TextBox
            name="facilityName"
            val={facilityName}
            onChange={handleChangeFacilityName}
            placeholder="Jobマ!ホーム"
            inValid={!!errorDispMap.facilityName}
            suggestText
          />
          <PcErrorArea position='relative' message={errorDispMap.facilityName} />
        </SpInputLine>

        <SpInputLine title="施設種類">
          <div className="sp-facilityType">
            {listValues.map((value) => {
              const choicelabel = getChoiceLabel(typeList.title, value);
              return (
                <NormalCheckBoxInput
                  checked={typeList.typeState.includes(value)}
                  key={choicelabel}
                  id={choicelabel}
                  label={choicelabel}
                  onChange={typeList.stateOnChange}
                  value={value}
                  color="0"
                />
              );
            })}
          </div>
          <PcErrorArea message={errorDispMap.facilityType} />
        </SpInputLine>

        <SpInputLine title="定員規模">
          <PulldownInput
            items={capacityList}
            selectedValue={capacity}
            onChange={handleChangeCapacity}
          />
          <PcErrorArea message={errorDispMap.capacity} />
        </SpInputLine>

        <SpInputLine title="ご担当者名">
          <TextBox
            name="userName"
            val={userName}
            onChange={handleChangeUserName}
            placeholder="例) 山田　太郎"
            maxLength="150"
            inValid={!!errorDispMap.userName}
          />
          <PcErrorArea position='relative' message={errorDispMap.userName} />
        </SpInputLine>

        <SpInputLine title="電話番号">
          <TextBox
            name="tel"
            val={tel}
            onChange={handleChangeTel}
            placeholder="03-1234-5678"
            inValid={!!errorDispMap.tel}
          />
          <PcErrorArea message={errorDispMap.tel} />
        </SpInputLine>

        <SpInputLine title="メールアドレス">
          <TextBox
            name="email"
            val={email}
            onChange={handleChangeEmail}
            placeholder="jobma@recruit.co.jp"
            maxLength="100"
            inValid={!!errorDispMap.email}
          />
          <PcErrorArea message={errorDispMap.email} />
        </SpInputLine>
        <SpInputLine title="メールアドレス(確認)">
          <TextBox
            name="emailConf"
            val={emailConf}
            onChange={handleChangeEmailConf}
            placeholder="jobma@recruit.co.jp"
            maxLength="100"
            inValid={!!errorDispMap.emailConf}
          />
          <PcErrorArea message={errorDispMap.emailConf} />
        </SpInputLine>

        <SpInputLine
          title="郵便番号"
          optional="true"
        >
          <span className="sp-zip">
            <TextBox
              name="zip"
              val={zip}
              onChange={handleChangeZip}
              placeholder="104-8001"
              maxLength="8"
              inValid={!!errorDispMap.zip}
              suggestText
            />
            <PcErrorArea message={errorDispMap.zip} />
          </span>
        </SpInputLine>

        <OutsideClickHandler onOutsideClick={handleClickAddressSuggestAway}>
          <div className="searchNamesWrapper">
            <div className="searchNames">
              {isOpenAddress && ( 
                <SpSuggestList
                  items={addressNames}
                  onClick={handleClickAddressSuggest}
                  fullWidth
                />
              )}
            </div>
          </div>
        </OutsideClickHandler>

        <SpInputLine title="市区町村">
          <TextBox
            name="municipality"
            val={municipality}
            onChange={handleChangeMunicipality}
            placeholder="東京都中央区銀座8丁目"
            maxLength="100"
            inValid={!!errorDispMap.municipality}
          />
          <PcErrorArea position='relative' message={errorDispMap.municipality} />
        </SpInputLine>
        <SpInputLine title="番地以降">
          <TextBox
            name="houseNumber"
            val={houseNumber}
            onChange={handleChangeHouseNumber}
            placeholder="4-17　リクルートGINZA8ビル"
            maxLength="100"
            inValid={!!errorDispMap.houseNumber}
          />
          <PcErrorArea position='relative' message={errorDispMap.houseNumber} />
        </SpInputLine>

      </SpBasicTemplate>
    </div>
  );
};

export default PresentSP;
